module.exports = __webpack_public_path__ + "img/image (15).f0640c89.png";